import React from "react"
import * as S from "./elements"
import { useIntl } from "@components/Intl"
import { FreeShipping, Authority } from "@components/Icons"
import { ParagraphS } from "@components/Typography"

export type Variant = "vertical" | "horizontal"

interface Props {
  variant?: Variant
}

export const ProductUSP: React.FC<Props> = ({ variant = "horizontal" }) => {
  const { messages } = useIntl()
  const items = [
    {
      icon: "certificate",
      text: messages.productDetail.patentedSystem,
    },
    {
      icon: "truck",
      text: messages.productDetail.freeShippingReturns,
    },
  ]

  return (
    <S.Wrapper variant={variant}>
      {items.map((item, key) => (
        <S.Item key={key} icon={item.icon}>
          {item.icon === "certificate" && <Authority />}
          {item.icon === "truck" && <FreeShipping />}
          <ParagraphS>{item.text}</ParagraphS>
        </S.Item>
      ))}
    </S.Wrapper>
  )
}
